import { render, staticRenderFns } from "./Checkups.vue?vue&type=template&id=e937f27a&"
import script from "./Checkups.vue?vue&type=script&lang=js&"
export * from "./Checkups.vue?vue&type=script&lang=js&"
import style0 from "./Checkups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports